/**
 * @param {Array} list
 * @param {String} [propertyName]
 *
 * @returns {Array}
 */
export default function sortEntitiesByAlphabet(list, propertyName = 'name') {
  const collator = new Intl.Collator('de', {sensitivity: 'base'});
  return list
    .sort(({[propertyName]: propertyA}, {[propertyName]: propertyB}) =>
      collator.compare((propertyA || '').toLowerCase(), (propertyB || '').toLowerCase()));
}
